import * as React from 'react';

import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-7 w-full rounded-md border border-[hsl(216_18%_38%)] bg-[hsl(216_42%_7%)] px-2 py-1 text-base text-[hsl(210_25%_96%)] transition-colors file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-[hsl(214_14%_62%)] hover:border-[hsl(216_18%_46%)] focus-visible:border-[#52a3df] focus-visible:shadow-[0_0_0_2px_hsl(206_69%_60%/.35)] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
